import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasJhpData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { JhpActions } from '../jhpActions';
import { IAppState } from '../appState';
import { buildTaasJhpDataForStrecke } from './transformer/jhpData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasJhpData>;

const TARIFIERUNG_SUCCESS_ACTIONS = [
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_JHP,
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_JHP,
];

export function* streckenTarifierungJHP(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    JhpActions.PREISE_REQUESTED,
    JhpActions.SELBSTBETEILIGUNG_CHANGED,
  ];
  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.JHP,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_JHP,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_JHP,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_JHP,
    },
    buildTaasJhpDataForStrecke,
    undefined,
    createHashedRelevantRiskdataJHP,
  );

  yield takeEvery(TARIFIERUNG_SUCCESS_ACTIONS, safeSaga(streckenTarifierer.handleSuccess, App.JHP));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_JHP,
    safeSaga(streckenTarifierer.handleError, App.JHP),
  );
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.JHP));
}

export function createHashedRelevantRiskdataJHP(taasData: TaasJhpData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;

  return createHashedTaasData(relevantData);
}
